import { Container, Box, Card, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Stream } from '@cloudflare/stream-react';
import GradientHeading from 'components/GradientHeading';
import useBoolean from 'hooks/useBoolean';

const TutorialVideo = () => {
    const videoId = '84ec90ae77a93f7527ae39ad9f6cfea2';
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const loading = useBoolean(true);

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
                <GradientHeading
                    label="Abstract Submission Tutorial"
                    variant="h4"
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box sx={{ width: isMd ? '80vw' : '90vw', maxWidth: 1200 }}>
                    <Box sx={{ position: 'relative' }}>
                        <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                            <Stream
                                controls
                                src={videoId}
                                autoplay={false}
                                muted={true}
                                style={{ display: 'block', width: '100%' }}
                                onCanPlay={() => loading.onFalse()}
                                onPlay={() => loading.onFalse()}
                            />
                        </Card>
                        {loading.value && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: 'rgba(255,255,255,0.6)',
                                    pointerEvents: 'none',
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Container>
    );
};

export default TutorialVideo;
